import WidgetPartPreview from './WidgetPartPreview';
export default WidgetPartPreview;
